import { actionTypes } from "../../actions/action_types";

const initialState = {
  customer_profiling_list: [],
};

export default function customer_profiling_reducer(
  state = initialState,
  action
) {
  var stateCopy = Object.assign({}, state);

  switch (action.type) {
    case actionTypes.REPORTS_CUSTOMERPROFILING_GET_OVERALL:
      stateCopy.customer_profiling_list = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_CUSTOMERPROFILING_GET_CLUSTER:
      stateCopy.customer_profiling_list = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_CUSTOMERPROFILING_GET_AREA:
      stateCopy.customer_profiling_list = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_CUSTOMERPROFILING_GET_BRANCH:
      stateCopy.customer_profiling_list = action.payload;
      return stateCopy;

    //.. DAILY
    case actionTypes.REPORTS_DAILY_CUSTOMERPROFILING_GET_OVERALL:
      stateCopy.customer_profiling_list = action.payload.customerProfiles;
      return stateCopy;

    case actionTypes.REPORTS_DAILY_CUSTOMERPROFILING_GET_CLUSTER:
      stateCopy.customer_profiling_list = action.payload.customerProfiles;
      return stateCopy;

    case actionTypes.REPORTS_DAILY_CUSTOMERPROFILING_GET_AREA:
      stateCopy.customer_profiling_list = action.payload.customerProfiles;
      return stateCopy;

    case actionTypes.REPORTS_DAILY_CUSTOMERPROFILING_GET_BRANCH:
      stateCopy.customer_profiling_list = action.payload.customerProfiles;
      return stateCopy;

    default:
      return state;
  }
}
